export const MENU_STATE_ADVISOR = "MENU_STATE_ADVISOR";
export const MENU_STATE_ADMIN = "MENU_STATE_ADMIN";
export const MENU_STATE_SUPERADMIN = "MENU_STATE_SUPERADMIN";
export const MENU_STATE_SWITCH_USER = "MENU_STATE_SWITCH_USER";